import { render } from "./WebhookIcon.vue?vue&type=template&id=d0d3ba0c"
import script from "./WebhookIcon.vue?vue&type=script&lang=js"
export * from "./WebhookIcon.vue?vue&type=script&lang=js"
script.render = render

export default script